import { ExplanationRevisionStatusV2 } from 'src/lib/gql-client'

/** 「同意完了」ステータスか否かを判定（for v2） */
export const isAgreementCompleted = (status: ExplanationRevisionStatusV2) => {
  return status === 'AgreementCompleted' || status === 'DeliveryCompleted'
}
